import { faGlobe, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { ReactElement, useContext, useEffect } from "react";
import { ProgressTracker as BaseProgressTracker, Button, Link } from "../common/components";
import { gap, marginBottom, marginRight, media } from "../common/styles";
import { emitEvent, useViewportSize } from "../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ActionType } from "../AppDataProvider/actions";
import { AppContext } from "../AppDataProvider/AppDataProvider";
import i18n from "../i18n";
export function Header(): ReactElement {
  const viewport = useViewportSize();
  const progressInHeader = viewport.width >= media.thresholds.progressInHeader && viewport.width < media.thresholds.desktop;
  const {
    t
  } = useTranslation();
  const {
    appDataDispatch,
    appData
  } = useContext(AppContext);
  const urlParams = new URLSearchParams(window.location.search);
  const iFrameId = urlParams.get("iFrameId") ?? undefined;
  const inPopoverMode = !!urlParams.get("inPopoverMode");
  useEffect(() => {
    if (iFrameId) {
      emitEvent({
        data: {
          iFrameId: iFrameId
        },
        name: "READY"
      });
    }
  }, [iFrameId]);
  const closePopover = (iFrameId: string) => {
    emitEvent({
      data: {
        iFrameId: iFrameId
      },
      name: "CLOSE_APPOINTEDD_POPOVER"
    });
  };

  // ESC Key handling
  useEffect(() => {
    const keydownHandler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        if (appData.nonModalDialog) {
          return appDataDispatch({
            type: ActionType.HIDE_NON_MODAL_DIALOG
          });
        }
        if (inPopoverMode && iFrameId) {
          closePopover(iFrameId);
        }
      }
    };
    document.addEventListener("keydown", keydownHandler);
    return () => {
      document.removeEventListener("keydown", keydownHandler);
    };
  }, [appData.nonModalDialog, appDataDispatch, iFrameId, inPopoverMode]);
  const showLanguageSelectorButton = !!urlParams.get("enableLanguageSelector");
  const showCloseButton = inPopoverMode;
  const showHeader = progressInHeader || showLanguageSelectorButton || !!(showCloseButton && iFrameId);
  return <HeaderContainer {...{
    showHeader
  }} data-sentry-element="HeaderContainer" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      {progressInHeader && <ProgressTracker />}
      {showLanguageSelectorButton && <LanguageSelector column={showCloseButton && iFrameId ? 3 : 4}>
          <FontAwesomeIcon icon={faGlobe} />
          <Link aria-label={t("languageSelectorAriaLabel")} onClick={() => {
        appDataDispatch({
          payload: {
            variant: "languageSelector"
          },
          type: ActionType.SHOW_NON_MODAL_DIALOG
        });
      }}>
            {i18n.language}
          </Link>
        </LanguageSelector>}
      {showCloseButton && iFrameId && <CloseButton className="popoverCloseButton" aria-label={t("closePopoverButtonLabel")} onClick={() => closePopover(iFrameId)}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>}
    </HeaderContainer>;
}
const HeaderContainer = styled.div<{
  showHeader: boolean;
}>`
  display: ${({
  showHeader
}) => showHeader ? "grid" : "none"};
  grid-template-columns: 2fr 10fr 1fr 1fr;
  ${marginBottom.s}
  @media ${media.desktop} {
    ${marginBottom.m}
  }
`;
const ProgressTracker = styled(BaseProgressTracker)`
  grid-column: 2;
  justify-self: center;
`;
const LanguageSelector = styled.div<{
  column: number;
}>`
  height: 100%;
  justify-self: right;
  grid-column: ${({
  column
}) => column};

  text-transform: uppercase;

  display: flex;
  flex-direction: row;
  align-items: start;
  ${marginRight.s}
  margin-top: 10%;

  ${gap.xs}

  svg {
    margin-top: 10%;
  }
`;
const CloseButton = styled(Button).attrs({
  variant: "tertiary"
})`
  justify-self: right;
  grid-column: 4;

  width: 3rem;
  height: 2.25rem;
`;
export default Header;